<template>
  <Loader2
    class="animate-spin"
    :size="props.size"
  />
</template>

<script setup lang="ts">
import {
  Loader2,
} from "@lucide/vue";

type PropsType = {
  size?: number;
};

const props = withDefaults(defineProps<PropsType>(), {
  size: 24,
});
</script>
